import { render, staticRenderFns } from "./r-reward-bunch-panel.vue?vue&type=template&id=6a5ab76e"
import script from "./r-reward-bunch-panel.vue?vue&type=script&lang=js"
export * from "./r-reward-bunch-panel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a5ab76e')) {
      api.createRecord('6a5ab76e', component.options)
    } else {
      api.reload('6a5ab76e', component.options)
    }
    module.hot.accept("./r-reward-bunch-panel.vue?vue&type=template&id=6a5ab76e", function () {
      api.rerender('6a5ab76e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reward/r-reward-bunch-panel.vue"
export default component.exports